// extracted by mini-css-extract-plugin
module.exports = {"objectFieldRow":"styles-module--objectFieldRow--3Ug8b","label":"styles-module--label--2SbIz","value":"styles-module--value--JJCIc"};